import React, { useEffect, useMemo, useState } from "react";
import {
  SEMANAS,
  obtenerNombreMes,
  totalRegistro,
  buscarRegistro,
  guardarRegistro,
} from "./datosFinancieros";

const semanasVacias = () =>
  SEMANAS.reduce((acc, semana) => ({ ...acc, [semana]: "" }), {});

const CargaDatos = ({ area }) => {
  const nombreMes = useMemo(obtenerNombreMes, []);
  const [valores, setValores] = useState(semanasVacias);

  useEffect(() => {
    const registro = buscarRegistro(area, nombreMes);
    setValores(
      SEMANAS.reduce(
        (acc, semana) => ({ ...acc, [semana]: registro?.[semana]?.toString() || "" }),
        {}
      )
    );
  }, [area, nombreMes]);

  const total = totalRegistro(valores);

  const guardarDatos = () => {
    guardarRegistro({
      area,
      mes: nombreMes,
      ...SEMANAS.reduce(
        (acc, semana) => ({ ...acc, [semana]: Number(valores[semana]) || 0 }),
        {}
      ),
      total,
      fechaActualizacion: new Date().toISOString(),
    });

    alert(`${area}: datos guardados correctamente`);
  };

  return (
    <div className="page-card">
      <h1 className="page-title">Carga de Datos</h1>

      <p className="carga-subtitle">
        Captura los resultados mensuales del área de {area}
      </p>

      <div className="carga-info-grid">
        <div className="fc-stat">
          <div className="fc-stat-label">Área Seleccionada</div>
          <div className="fc-stat-value">{area}</div>
        </div>
        <div className="fc-stat">
          <div className="fc-stat-label">Mes</div>
          <div className="fc-stat-value">{nombreMes}</div>
        </div>
      </div>

      <div className="carga-form">
        <div className="carga-semanas-grid">
          {SEMANAS.map((semana, index) => (
            <div className="fc-semana" key={semana}>
              <label className="fc-semana-label" htmlFor={`fc-${semana}`}>
                Semana {index + 1}
              </label>
              <input
                id={`fc-${semana}`}
                className="fc-semana-input"
                type="number"
                placeholder="0"
                value={valores[semana]}
                onChange={(e) =>
                  setValores((prev) => ({ ...prev, [semana]: e.target.value }))
                }
              />
            </div>
          ))}
        </div>

        <div className="fc-total">
          <div className="fc-total-label">Total acumulado</div>
          <div className="fc-total-value">{total.toLocaleString()}</div>
        </div>

        <button type="button" onClick={guardarDatos} className="carga-save-button">
          Guardar Datos
        </button>
      </div>
    </div>
  );
};

export default CargaDatos;